import Vue from 'vue'
import VueRouter from 'vue-router'
import zh from '@/views/zh.vue';
import en from '@/views/en.vue';
import ja from '@/views/ja.vue';
import ko from '@/views/ko.vue';
import pt from '@/views/pt.vue';
import es from '@/views/es.vue';
import de from '@/views/de.vue';
import ru from '@/views/ru.vue';
import fr from '@/views/fr.vue';
import it from '@/views/it.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/enUserprotocol',
		component: en,
		meta: {
			title: 'Ix cam cloud storage automatic renewal service agreement'
		}
	},
	{
		path: '/enUserprotocol',
		name: 'enUserprotocol',
		component: en,
		meta: {
			title: 'Ix cam cloud storage automatic renewal service agreement'
		}
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: zh,
		meta: {
			title: 'Ix cam云存储自动续费服务协议'
		}
	},
	{
		path: '/jaUserprotocol',
		name: 'jaUserprotocol',
		component: ja,
		meta: {
			title: 'Ix Cam クラウドストレージ自動更新サービス契約'
		}
	},
	{
		path: '/esUserprotocol',
		name: 'esUserprotocol',
		component: es,
		meta: {
			title: 'Acuerdo de renovación automática del servicio de almacenamiento en la nube de ix-cam'
		}
	},
	{
		path: '/ptUserprotocol',
		name: 'ptUserprotocol',
		component: pt,
		meta: {
			title: 'Contrato de serviço de renovação automática de armazenamento em nuvem ix cam'
		}
	},
	{
		path: '/ruUserprotocol',
		name: 'ruUserprotocol',
		component: ru,
		meta: {
			title: 'Соглашение об автоматическом продлении обслуживания облачного хранилища ix cam'
		}
	},
	{
		path: '/deUserprotocol',
		name: 'deUserprotocol',
		component: de,
		meta: {
			title: 'Servicevertrag zur automatischen Verlängerung des ix cam Cloud-Speichers'
		}
	},
	{
		path: '/koUserprotocol',
		name: 'koUserprotocol',
		component: ko,
		meta: {
			title: 'Ix cam 클라우드 스토리지 자동 갱신 서비스 계약'
		}
	},
	{
		path: '/frUserprotocol',
		name: 'frUserprotocol',
		component: fr,
		meta: {
			title: 'Contrat de service de renouvellement automatique du stockage infonuagique Ix cam'
		}
	},
	{
		path: '/itUserProtocol',
		name: 'itUserProtocol',
		component: it,
		meta: {
			title: "Contratto di servizio di rinnovo automatico dell'archiviazione cloud Ixcam"
		}
	},
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
